import { render, staticRenderFns } from "./carruselHerramientas.vue?vue&type=template&id=7a84c640&scoped=true"
import script from "./carruselHerramientas.vue?vue&type=script&lang=js"
export * from "./carruselHerramientas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84c640",
  null
  
)

export default component.exports